import { render, staticRenderFns } from "./SettingsSocialMedia.vue?vue&type=template&id=8749ad38&"
import script from "./SettingsSocialMedia.vue?vue&type=script&lang=ts&"
export * from "./SettingsSocialMedia.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports